import React, { useContext, useEffect, useMemo, useState } from "react";

import './GrillasStyles.css'; //Con importar los estilos de grillas aqui, ya queda aplicado para GrillaDocumentos y GrillaProcsProgramados.
import controlContext from "../../context/control/controlContext";
import authContext from "../../context/authentication/authContex";
import informesContext from "../../context/informesContext/informesContext";
import { STATES } from "../../utils/states";
import normalizeText from "../../utils/normalizeText";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";
import SearchInput from "../searchInput/SearchInput";
import AddFilter from "../addFilter/AddFilter";
import FilterScreen from "../filterScreen/FilterScreen";
import usuariosContext from "../../context/usuarios/usuariosContext";
import SelectColumns from "./SelectColumns";
import Table from "./Table";
import productsContext from "../../context/productos/productsContext";
import Select from 'react-select';
import AddFilterSmaller from "../addFilter/AddFilterSmaller";
import moment from "moment";
import Swal from "sweetalert2";

const GrillaConsumibles = ({setGridToShow}) => {

     //Context control requerimientos
     const cContext = useContext(controlContext);
     const {
         listTDocReporte,
         filtrosRango, 
         filtrosEstado,
         modificarFiltrosEstado,
         modificarFiltrosRango,
         iniciarFiltrosReporte,
         getProductsByNroFor,
         filtrar
     } = cContext;
 
     const uContext = useContext(usuariosContext);
     const {userListView, saveColumnsPreferences} = uContext
 
     const aContext = useContext(authContext);
     const { usuario } = aContext;
 
     const iContext = useContext(informesContext);
     const {generarInformeExcel} = iContext;

     const {getDataByProduct} = useContext(productsContext);
     
    let columnsPreferences = useMemo(()=> usuario?.columnsPreferences?.columnasOrdenesTrabajo ?? [], [usuario])
    

    const createDefaultCols = () => [
        {width: 200, property: 'codActivo', title: 'Activo Cod.', visible: true },
        {width: 200, property: 'nameActivo', title: 'Activo', visible: true },
        {width: 200, property: 'totalConsumed', title: 'Cantidad Total', visible: true, totalizator: true, value: 0 },
    ];
    const [columns, setColumns] = useState([...createDefaultCols()]);    

    const [permantentOTs,setPermanentOTs] = useState(undefined);
    const [OTsFiltered,setOTsFiltered] = useState(permantentOTs);
    const [showFilters,setShowFilter] = useState(false);
    const [filter, setFilter] = useState('');
    const [showSelectColumns,setShowSelectColumns] = useState(false);
    const [loading,setLoading] = useState(true);
    const {products} = useContext(productsContext);
    const [productToGet, setProductToGet] = useState(null);
    const [productData, setProductData] = useState(null);
    const [periodo,setPeriodo] = useState({periodoBase: moment().format('MM/YYYY')});

    const productsOptions = useMemo(()=> products?.filter(p => p.enableCons).map(p => ({label:p.descrp, value:p.artCod, tippro: p.tipPro, artcod: p.artCod}) ?? []), [products]);

    const handleGenerarInforme = async() =>{
        let dataToExcel = []; //Arreglo que contendra tanto el Header del excel como las Filas Hijas de Informacion.
        let columnsTitle = columns.filter(c => c.visible).map(c => c.title); //Arreglo que contiene el nombre de las columnas o header.
        dataToExcel.push(columnsTitle); //Se pushea la primer fila del excel.

        //Por cada OT filtrada se crea un array nuevo, a este se le pushearan las propiedades que hayan sido especificadas en la visualizacion del informe en el frontend.
        for(const o of productData){
            let otModelado = [];
            for(const col of columns){
                if(!col.visible) continue;
                (Array.isArray(o[col.property])) ? otModelado.push(o[col.property].length) : (col.property == 'fecAlt') ? otModelado.push(o[col.property].toLocaleString().substring(0,16).replace("T", " ")) : (col.property == 'valorMaterialesString') ?  otModelado.push(o["valorMateriales"]) : (col.property == 'valorRRHHString') ?  otModelado.push(o["valorRRHH"]) : otModelado.push(o[col.property]);
            }
            if(otModelado.length > 0) dataToExcel.push(otModelado); //Si algun campo coincidio lo pushea a dataToExcel para ser impresa en el .xlsx.
        }
        await generarInformeExcel(dataToExcel, 'GrillaConsumibles'); //Viaja hacia la funcion del contexto para ser generado el xlsx.
    }


    const handleChangeColumnsVisible = (e, c, i) =>{
        setColumns((prevCols) => prevCols.map((c,index) => index == i ? {...c, visible: e.target.checked} : c))
    }

    const handlerClickFilter = (itm) => {
        setShowFilter(false)
    }

    const modelateTable = () => {
        try {
            let quantityTotal = 0;
            if(productData && productData.length > 0){
                
                let days = productData[0].days.map(d => ({width: 200, property: d.day, title:d.day, visible:true, totalizator: true, value: 0 }));

                let dataModelated = productData.map(p => {
                    let result = {
                        activo: p.activo, codActivo: p.codActivo, nameActivo: p.nameActivo, totalConsumed: p.totalConsumed
                    }

                    p.days.forEach((d, i) => {
                        if(d){
                            result[d.day] = d.total;
                            days[i].value+= d.total;
                        }
                    })

                    quantityTotal += p.totalConsumed;

                    return result;
                });

                setColumns(prev => {
                    let newCols = [...prev];
                    let indexColTotales = newCols.findIndex(c => c.property == 'totalConsumed');
                    newCols[indexColTotales].value = quantityTotal;
                    return [...newCols, ...days];
                })
                setProductData(dataModelated);
            }else return false;
        } catch (error) {
            console.log("error al modelar tabla en GrillaConsumibles");
            console.log(error);
        }
    }
 
    const handleChangePeriodo = async (value) => {
        if(value != periodo){
            setPeriodo(value);
            setLoading(true);
            setColumns([...createDefaultCols()]);
            if(productToGet){
                let res = await getDataByProduct(productToGet, value.periodoBase);
                if(res){
                    setProductData(res);
                    setLoading(false);
                }else{
                    Swal.fire({title:'Ops!', text:'No pudo recuperarse la información sobre consumos de este producto.', icon:'error'});
                }
            }
        }
    }

    const getProductInfo = async (p) => {
        if(!productToGet || p.value != productToGet.value){
            setProductToGet(p);
            setLoading(true);
            setColumns([...createDefaultCols()]);
            let res = await getDataByProduct(p, periodo.periodoBase);
            if(res){
                setProductData(res);
                setLoading(false);
            }else{
                Swal.fire({title:'Ops!', text:'No pudo recuperarse la información sobre consumos de este producto.', icon:'error'});
            }
        }
    }

    useEffect(()=>{
        if(productData?.length > 0){
            console.log("productData en useEffect de filter");
            console.log(productData);
            
            if(filter != ''){
                const nFilter = normalizeText(filter);
                let OTs = permantentOTs.filter(r => normalizeText(r.title).includes(nFilter) || normalizeText(r.tDocNroFor.toString()).includes(nFilter) || normalizeText(`${r.tDocCodFor} - ${r.tDocNroFor}`).includes(nFilter));
                modelateTable(OTs);
                setOTsFiltered(OTs);
            }else if(listTDocReporte){
                let OTs = permantentOTs;
                modelateTable(OTs);
                setOTsFiltered(OTs);
            }
        }
    },[filter]);

    useEffect(() => {
        modelateTable();
    }, [productData])

    useEffect(()=>{
        // if(columnsPreferences && columnsPreferences.length > 0){
        //     setColumns(prevColumns => prevColumns.map(c => ({...c, visible: columnsPreferences.includes(c.property)})))
        // }
    },[columnsPreferences]);

    return <div className="grillaInformeDiv">
        <div className="utilitiesDiv">
            <button onClick={()=>setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
            {/* <SearchInput filter={filter} buscar={setFilter}/> */}
            <Select
                styles={{
                    input: (base) => ({
                        ...base,
                        width: "100%",
                        padding: ".4rem",
                        borderRadius: ".5rem",
                        fontSize: "1rem",
                        transition: "border-color .5s",
                    }),
                    container: (base) => ({
                        ...base,
                        position:'absolute',
                        left:'55%',
                        width:'50%',
                        transform:'translate(-50%)',
                        marginTop: 56
                    })
                }}
                placeholder="Selecciona el consumible a visualizar"
                options={productsOptions}            
                onChange={(selectedOption) => getProductInfo(selectedOption)}
            />
            <FilterScreen verFiltro={setShowFilter}/>
            <button className="selectColumnsBtn" onClick={()=>setShowSelectColumns(true)}><FontAwesomeIcon className="iconArrowBack" icon={faTableCells}/></button>
            <button disabled={loading || !productData} className="downloadBtn" onClick={handleGenerarInforme}>Descargar .xlsx <FontAwesomeIcon className="iconArrowBack" icon={faDownload}/></button>
        </div>
        {
            productToGet && <div className="headerInfoGrillaConsumibles">
                <h4 className="productSelected">
                    <span>Producto Seleccionado:</span>
                    <span>{productToGet.value} - {productToGet.label}</span>
                </h4>
                <h5>Periodo Seleccionado: {periodo.periodoBase}</h5>
            </div>
        }
        {
            !productToGet ? <h3 className="warningStatusMsg">Seleccione un consumible para comenzar</h3> : ((productData == undefined || loading ) && productToGet) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> : (productData.length == 0) ? <h3 className="warningStatusMsg">No hay ordenes de trabajo cargadas</h3> : <Table array={productData} columns={columns} setColumns={setColumns} componentePadre={'GrillaConsumibles'}/>
        }
        {
            showSelectColumns && <SelectColumns setShowSelectColumns={setShowSelectColumns} handleChangeColumnsVisible={handleChangeColumnsVisible} columns={columns} saveColumnsPreferences={saveColumnsPreferences} usuario={usuario} columnsName={"OrdenesTrabajo"}/>
        }
        {showFilters &&
                <div className="addFilterContainer">
                    <AddFilterSmaller
                        filtro={periodo} 
                        aplicarFiltros={handleChangePeriodo} 
                        cerrar={handlerClickFilter} 
                        componentePadre="GrillaConsumibles"
                    />
                </div>
            }
    </div>
}

export default GrillaConsumibles;